import { s } from '@/theme/tokens';
import type { SxProps, Theme } from '@/ui/primitives';

export const tablePanelSurfaceSx = {
  width: '100%',
  minWidth: 0,
  py: s('none'),
  px: s('md'),
  backgroundColor: (theme) => `${theme.app.colors.surface} !important`,
} satisfies SxProps<Theme>;
